import React, { useState, isValidElement, ReactNode } from 'react';
import { Switch } from 'new/elements/Switch';

import * as S from './styles';

type Props = {
  title: string;
  switchTitle: string;
  DefaultComponent: ReactNode;
  SwitchableComponent: ReactNode;
};

enum SectionKeys {
  FIRST = 'first',
  SECOND = 'second',
}

export function SwitchableSection(props: Props) {
  const { title = '', switchTitle = 'switch', DefaultComponent, SwitchableComponent } = props;

  const [current, setCurrent] = useState('first');

  const invalid = !isValidElement(DefaultComponent) || !isValidElement(SwitchableComponent);

  if (invalid) {
    const errorMessage =
      'SwitchableSection:  DefaultComponent and SwitchableComponent must be a valid component';
    console.error(errorMessage);
    return null;
  }

  const elements = {
    [SectionKeys.FIRST]: DefaultComponent,
    [SectionKeys.SECOND]: SwitchableComponent,
  };

  const onChange = () => {
    setCurrent((prevState) =>
      prevState === SectionKeys.FIRST ? SectionKeys.SECOND : SectionKeys.FIRST,
    );
  };

  return (
    <S.Container>
      <div className="header">
        <S.Title>{title}</S.Title>
        <S.SwitchContainer>
          <Switch checked={current === SectionKeys.SECOND} onChange={onChange} />
          <span className="switch-title">{switchTitle}</span>
        </S.SwitchContainer>
      </div>

      <div className="content">{elements[current]}</div>
    </S.Container>
  );
}
